
import LayoutContent from '../../components/layouts/content2';
import React, { useEffect, useState, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import { getImage , getData} from '../../helpers/indexedDbHelper';
import { Link } from 'react-router-dom';
import {useTranslation} from 'react-i18next';
import translate from '../../helpers/translate';
import translateMenu from '../../helpers/translateMenu';
import DetailProduct from './DetailProduct';
import SpecialsScreen from './specials';
import ChaufaScreen from './chaufa';
import CevicheScreen from './ceviche';
import ExecutivemenuScreen from './executiveMenu';
import BarScreen from './bar';

import HotDrinksScreen from './hotdrink';
import CoolDrinksScreen from './cooldrink';
import NaturalJuiceScreen from './narutalJuice';

function Index({dishs, setShowListProduct, goHome}) { 

    const {i18n} = useTranslation();
    const langEng = i18n.language === 'en' ?? false;

    const { menus: menusCurrent, name: title } = dishs;

    const [showSpecials, setShowSpecials] = useState(false);

    const [titleCategorie, setIitleCategorie] = useState('');

    const [showDetailProduct, setShowDetailProduct] = useState(false);
    const [dataDish, setDataDish] = useState(false);

      const [menusData, setMenusData] = useState([]);

    const [menus, setMenus] = useState(menusCurrent);
    const categoriesScrollRef = useRef(null);

     const [showChaufa, setShowChaufa] = useState(false);
    const [showCeviche, setShowCeviche] = useState(false);
    const [showHotDrinks, setShowHotDrinks] = useState(false);
    const [showCoolDrinks, setShowCoolDrinks] = useState(false);    
    const [showNaturalJuice, setShowNaturalJuice] = useState(false);

    
      useEffect(() => {
            getData('menu').then((items) => {
                const data = items.value.data;
                setMenusData(data);
            });
        }, []);
        
    useEffect(() => {
        if (menus) {
            console.log({menus});
           
            
            // setIitleCategorie(langEng ? 
            //     dishs.name
            //     :    
            //     translate(i18n.language, dishs.language, dishs.name)
            // )
        }
    }, [menus]);


    


    const fetchImage = async (id) => {
        const imageBlob = await getImage(id);
        if (imageBlob) {
            const imageURL = URL.createObjectURL(imageBlob.data.blob);
            return imageURL;
        }
        return null;
    };


    const Item = ({ data }) => {
        const [image, setImage] = useState(false);
        useEffect(() => {
            fetchImage(`menu-image-${data.id}`).then((url) => {
                if (url) {
                    setImage(url);
                    
                }
            });
        }, []);
        
        return (
           <div onClick={()=>[setShowDetailProduct(true), setDataDish({ dish: data, alldish: menus, currentDish: dishs })]}  style={{
                backgroundColor: '#feba28', marginBottom: 30, textDecoration: 'none', 
                width: '100%',
                 height: 390,
                margin: '15px 0px',
                textAlign: 'left',
                paddingBottom: 40,
                position: 'relative',
                  borderRadius: 30,
            }}>
                <img src={image}  style={{width: '100%', height: 320, objectFit: 'cover',    borderRadius: 30,}}/>
                <h3 style={
                    { fontFamily: "Arial", fontWeight: '900', color: '#000', fontStyle: 'italic',textTransform: 'uppercase', fontSize: 30, margin: 0, textAlign: 'center' }
                    }> {langEng ? data.name : translate(i18n.language, data.language, data.name)}</h3>
                
                <div style={{width: '80%', margin: '0 auto'}}>
                    <p
                        className='shor-text'
                        style={{ fontFamily: "Rockwell",fontSize: 15, color: '#000', textAlign: 'center', margin: 0,}}>

                        { data.regular_decription
                        }
                        
                        
                    </p>
                </div>

                {/* <div style={{
                      width: '100%',
                        alignSelf: 'center',
                        backgroundColor: '#EAA60E',
                        borderColor: '#0073C1',
                        padding: '10px 0px',
                        marginTop: 20,
                        borderRadius: 9,
                        position: 'absolute',
                        bottom: 0,
                }}>
                <div
                    style={data.price2
                            ? {
                            display: 'flex',
                            flexDirection: 'row',
                            justifyContent: 'space-between',
                            padding: '0 20px'
                        }
                        : {}}>
                    <p
                    style={
                        {
                        color: '#000',
                        fontSize: 18,
                        fontWeight: 'bold',
                        textAlign: 'center',
                        }
                    }>
                            
                            {data.flavors == 0 ? '': 'SEE OPTIONS'}
                       
                            {data.flavors == 0 && 
                            <>
                            {data.price > 0 
                                ? `${data.label_price ?? ''} $${data.price.toFixed(2)}`
                            : 'Market Price'}
                            </>}
                            
                       
                    </p>

            {data.price2 && (
              <p
                style={
                  {
                    color: '#000',
                    fontSize: 18,
                    fontWeight: 'bold',
                    textAlign: 'center',
                  }
                }>
                {data.price > 0
                  ? `${data.label_price2 ?? ''} $${data.price2.toFixed(2)}`
                  : 'Market Price'}
              </p>
            )}
          </div>
                </div> */}
                

                
                
            </div>
        );
    }

  

    return (
        <div style={{position: 'absolute', top: 0, left: 0, width: '100%', height: '100%', zIndex: 9999}}>
            <LayoutContent showBack={true} showsocial={false} goHome={goHome} setShowListProduct={setShowListProduct}  setShowSpecials={setShowSpecials}>
                <div >

                    <div style={{ width: '90%', margin: '0 auto', position: 'relative', overflow: 'visible', zIndex: 500}}>
                        <div style={{ overflow: 'hidden', width: '100%' }}>
                            <div
                                ref={categoriesScrollRef}
                                style={{
                                    display: 'flex',
                                    padding: '10px 20px',
                                    gap: 10,
                                    justifyContent: 'flex-start',
                                    overflow: 'scroll',
                                    position: 'relative',
                                    zIndex: 100,
                                    borderRadius: 14,
                                    width: '100%',
                                }}>
                            {menusData.map((item, key) => {
                                if (![443, 444, 445, 446, 447, 448, 449, 450, 429, 430, 425, 424, 555, 565, 564, 566, 567].includes(item.id)) {
                                    return <div
                                        key={key}
                                        style={{
                                            alignItems: "center",
                                            padding: 4,
                                            borderRadius: 999,
                                            position: 'relative',
                                            minWidth: 142,
                                            height: 70,
                                            display: 'flex',
                                            justifyContent: 'center',
                                            alignItems: 'center',
                                            background: 'linear-gradient(180deg, #D6D6D6 0%, #BDBDBD 100%)',
                                            boxShadow: '0 2px 8px rgba(0,0,0,0.25)',
                                            cursor: 'pointer'
                                        }}
                                        onClick={() => {


                                            if (item.id === 686) {
                                                setShowChaufa(true)
                                            }
                                            else if (item.id === 685) {
                                                setShowCeviche(true)
                                            }
                                            else if (item.id === 690) {
                                                setShowHotDrinks(true)
                                            }
                                            else if (item.id === 689) {
                                                setShowCoolDrinks(true)
                                            }
                                            else if (item.id === 691) {
                                                setShowNaturalJuice(true)
                                            } else {
                                                setIitleCategorie(langEng
                                                ? item.name
                                                :
                                                translate(i18n.language, item.language, item.name)
                                            )
                                            setMenus(item.menus)
                                            }
                                
                                            
                                        }}
                                    >
                                        <div
                                            style={{
                                                width: '100%',
                                                height: '100%',
                                                borderRadius: 999,
                                                display: 'flex',
                                                justifyContent: 'center',
                                                alignItems: 'center',
                                                background: 'linear-gradient(180deg, #FFFFFF 0%, #E9E9E9 100%)',
                                                boxShadow: 'inset 0 4px 8px rgba(0,0,0,0.10), inset 0 -4px 8px rgba(0,0,0,0.18)'
                                            }}
                                        >
                                            <p
                                                className='shor-text'
                                                style={{
                                                    color: '#8C8C8C',
                                                    fontSize: 18,
                                                    width: '100%',
                                                    textAlign: 'center',
                                                    fontFamily: 'Poltawski',
                                                    fontWeight: 800,
                                                    fontStyle: 'italic',
                                                    textTransform: 'uppercase',
                                                    margin: 0
                                                }}
                                            >
                                                {translate(i18n.language, item.language, item.name)}
                                            </p>
                                        </div>
                                    </div>
                                }
                                
                            })}
                            </div>
                        </div>
                        <div
                            style={{
                                position: 'absolute',
                                zIndex: 9000,
                                top: '50%',
                                left: -25,
                                transform: 'translateY(-50%)'
                            }}>
                            <div
                                style={{
                                    width: 45,
                                    height: 45,
                                  
                                    borderRadius: 100,
                                    borderWidth: 3,
                                    borderColor: 'white',
                                    display: 'flex',
                                    justifyContent: 'center',
                                    alignItems: 'center',
                                    cursor: 'pointer'
                                }}
                                onClick={() => categoriesScrollRef.current && categoriesScrollRef.current.scrollBy({ left: -250, behavior: 'smooth' })}
                            >
                                <img
                                    style={{width: 30, height: 30, objectFit: 'contain'}}
                                    src={require('./assets/right.png')}
                                />
                            </div>
                        </div>
                        <div
                            style={{
                                position: 'absolute',
                                zIndex: 999,
                                top: '50%',
                                right: -35,
                                transform: 'translateY(-50%)'
                            }}>
                            <div
                                style={{
                                    width: 45,
                                    height: 45,
                                 
                                    borderRadius: 100,
                                    borderWidth: 3,
                                    borderColor: 'white',
                                    display: 'flex',
                                    justifyContent: 'center',
                                    alignItems: 'center',
                                    cursor: 'pointer'
                                }}
                                onClick={() => categoriesScrollRef.current && categoriesScrollRef.current.scrollBy({ left: 250, behavior: 'smooth' })}
                            >
                                <img
                                    style={{width: 30, height: 30, objectFit: 'contain'}}
                                    src={require('./assets/left.png')}
                                />
                            </div>
                        </div>
                    </div>


                    
                    
                    <div style={{
                        zIndex: -1,
                        display: 'flex',
                        flexDirection: 'row',
                        alignItems: 'center',
                        justifyContent: 'center',
                        padding: '0 40px',
                          marginTop: 10,
                    
                    }}>
                        <p style={{
                            fontFamily: "Arial",
                            fontSize: 35,
                            color: '#fff',
                            margin: 0,
                            fontWeight: 'bold',
                            fontStyle:'italic',
                        }}>{titleCategorie}</p>
                        
                        
                    </div>
                   
                        {dishs.id === 632 && <div>
                            <p style={{ fontFamily: "Arial", fontSize: 12, color: 'white', margin: 0 }}>
                            {langEng ? 'Available from 12-4pm' : 'Disponible de 12-4pm'}
                            </p></div>}


                    <div style={{
                            flexDirection: 'column',
                            padding: '0px 40px 100px 40px',
                            height:560,
                            overflow: 'scroll',
                            
                        }}>
                            {menus.map((item, key) => (
                                <Item data={ item }  key={key} />
                            ))}
                    </div>   
                    
      

                
                
                </div>
                {showDetailProduct && <DetailProduct
                    dishMenu={dataDish}
                    setShowListProduct2={setShowListProduct}
                    setShowDetailProduct={setShowDetailProduct}
                />}

                {showSpecials && <SpecialsScreen setShowListProduct={setShowSpecials} setShowHappy={setShowListProduct} />}
                 {showChaufa && <ChaufaScreen setShowHappy={setShowChaufa} />}
                {showCeviche && <CevicheScreen setShowHappy={setShowCeviche} />}
                {showHotDrinks && <HotDrinksScreen setShowHappy={setShowHotDrinks} />}
            {showCoolDrinks && <CoolDrinksScreen setShowHappy={setShowCoolDrinks} />}
                {showNaturalJuice && <NaturalJuiceScreen setShowHappy={setShowNaturalJuice} />}
                

            </LayoutContent>
        </div>
    );
}
export default Index;